import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useSetUserTutorialViewedMutation as UseSetUserTutorialViewedMutation,
  type useSetUserTutorialViewedMutation$data
} from '@/__generated__/useSetUserTutorialViewedMutation.graphql'

type CommitAsyncFn = () => Promise<useSetUserTutorialViewedMutation$data>

export const useSetUserTutorialViewedMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseSetUserTutorialViewedMutation>(graphql`
    mutation useSetUserTutorialViewedMutation($input: SetUserTutorialViewedInput!) {
      setUserTutorialViewed(input: $input) {
        clientMutationId
        user {
          tutorialViewedAt
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    () =>
      new Promise<useSetUserTutorialViewedMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              clientMutationId: 'setUserTutorialViewed'
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
